import React from 'react';
import styled from 'styled-components';
import { IconScanCheck as ScanCheckMisc } from '../Misc/ScanCheck';
const Wrapper = styled.div `
  .scan-data {
    opacity: 1;
    clip-path: url(#scanDataClip);
  }

  /* Keeps the reveal edge on the scan line: the same timing as scanLightContainerMove, shifted so the
   * rect's right edge (x=32) sits at the line's center (x=16). */
  .scan-data-clip {
    transform: translateX(-26px);
    animation: scanDataClipMove 2s ease-in-out infinite;
  }

  .scan-light-container {
    transform: translateX(-10px);
    animation: scanLightContainerMove 2s ease-in-out infinite;
  }

  .scan-light {
    opacity: 0;
    transform: scaleY(0.6);
    transform-origin: center;
    animation: scanLightFade 2s ease-in-out infinite;
  }

  .scan-line {
    transform: scaleY(0.6);
    transform-origin: center;
    animation: scanLineScale 2s ease-in-out infinite;
  }

  @keyframes scanLightContainerMove {
    0%,
    100% {
      transform: translateX(-10px);
    }
    50% {
      transform: translateX(10px);
    }
  }

  @keyframes scanDataClipMove {
    0%,
    100% {
      transform: translateX(-26px);
    }
    50% {
      transform: translateX(-6px);
    }
  }

  @keyframes scanLightFade {
    0%,
    100% {
      transform: scaleY(0.6);
      opacity: 0;
    }
    50% {
      opacity: 1;
      transform: scaleY(1);
    }
  }

  @keyframes scanLineScale {
    0%,
    100% {
      transform: scaleY(0.6);
    }
    50% {
      transform: scaleY(1);
    }
  }
`;
const ScanCheck = styled(ScanCheckMisc) `
  svg {
    --icon-size: 32px;
  }
`;
export const IconScanCheck = (props) => {
    return (React.createElement(Wrapper, { className: props.className },
        React.createElement(ScanCheck, null)));
};
//# sourceMappingURL=ScanCheck.js.map